import React, { useState } from "react";
import { supabase } from "./supabaseClient";

export default function UpdatePassword({ onComplete }) {
    const [password, setPassword] = useState("");
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleUpdate = async (e) => {
        e.preventDefault();
        if (password.length < 6) {
            setMessage("Password must be at least 6 characters.");
            return;
        }

        setLoading(true);
        setMessage("");

        const { error } = await supabase.auth.updateUser({ password });

        if (error) {
            console.error("Update Password Error:", error);
            setMessage(`Error: ${error.message}`);
        } else {
            setMessage("Password updated successfully!");
            // Briefly show success then redirect/close
            setTimeout(() => {
                onComplete();
            }, 2000);
        }
        setLoading(false);
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-canvas px-4">
            <div className="card w-full max-w-md p-8">
                <div className="mb-6">
                    <h1 className="font-display text-2xl font-semibold text-ink">Create a new password</h1>
                    <p className="mt-1 text-sm text-ink-muted">Enter a new secure password for your account.</p>
                </div>

                <form onSubmit={handleUpdate} className="space-y-4">
                    <div>
                        <label className="label" htmlFor="new-password">New password</label>
                        <input
                            id="new-password"
                            className="input"
                            type="password"
                            placeholder="••••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>

                    <button type="submit" disabled={loading} className="btn-primary w-full">
                        {loading ? "Updating…" : "Update password"}
                    </button>

                    {message && (
                        <div className={`rounded-lg border p-3 text-sm ${message.includes("successfully") ? 'border-success/30 bg-success-soft text-success' : 'border-danger/30 bg-danger-soft text-danger'}`}>
                            {message}
                        </div>
                    )}
                </form>
            </div>
        </div>
    );
}
